import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

// ** Emotion Imports
import { CacheProvider } from "@emotion/react";

// ** Utils Imports
import { createEmotionCache } from "./@core/utils/create-emotion-cache";

// ** Contexts
// import { AuthProvider } from "./context/AuthContext";
import {
  SettingsConsumer,
  SettingsProvider,
} from "./@core/context/settingsContext";

// ** Component Imports
import ThemeComponent from "./@core/theme/ThemeComponent";

// ** Styled Components
import ReactHotToast from "src/@core/styles/libs/react-hot-toast";

// ** Third Party Import
import { Toaster } from "react-hot-toast";

// ** Redux Import **
import store from "src/redux/store";
import { Provider } from "react-redux";

// ** MiddleWare Auth Handler
import AuthHandler from "./redux/AuthHandler";

// ** TanStack Query
// import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { QueryClient, QueryClientProvider } from "react-query";
import Loader from "./@core/components/loader";
// import ClientProvider from './react-query';

const root = ReactDOM.createRoot(document.getElementById("root"));
const emotionCache = createEmotionCache();
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <CacheProvider value={emotionCache}>
        <BrowserRouter>
          <SettingsProvider>
            <SettingsConsumer>
              {({ settings }) => {
                return (
                  <ThemeComponent settings={settings}>
                    {/* <AuthProvider> */}
                    <QueryClientProvider client={queryClient}>
                      <AuthHandler>
                        <App />
                        <ReactHotToast>
                          <Toaster
                            position={settings.toastPosition}
                            toastOptions={{ className: "react-hot-toast" }}
                          />
                        </ReactHotToast>
                      </AuthHandler>
                    </QueryClientProvider>
                    {/* </AuthProvider> */}
                    <Loader />
                  </ThemeComponent>
                );
              }}
            </SettingsConsumer>
          </SettingsProvider>
        </BrowserRouter>
      </CacheProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
